import { getApiBaseUrl } from '../../utils/apiConfig';

async function documentationRequest(endpoint) {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${getApiBaseUrl()}${endpoint}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Erro desconhecido' }));
    throw new Error(errorData.message || `Erro ao buscar dados: ${response.status}`);
  }

  return response.json();
}

export function fetchBooks() {
  return documentationRequest('/api/documentation/books');
}

export function fetchBook(bookId) {
  return documentationRequest(`/api/documentation/books/${bookId}`);
}

export function fetchPage(pageId) {
  return documentationRequest(`/api/documentation/pages/${pageId}`);
}

export function fetchPagesQuery(queryString) {
  const qs = queryString ? (queryString.startsWith('?') ? queryString : `?${queryString}`) : '';
  return documentationRequest(`/api/documentation/pages${qs}`);
}

export function searchDocumentation(query) {
  return documentationRequest(`/api/documentation/search?query=${encodeURIComponent(query.trim())}`);
}

export function unwrapData(result) {
  if (result?.success) return result.data;
  if (Array.isArray(result)) return result;
  if (result?.data) return result.data;
  return result;
}
